module.exports = __webpack_public_path__ + "static/cta-banner-59ca04d1fce5ed2bfb40346a6e9ad304.jpg";